
function toCartesian(points){
  return points.map(d => [
    d[0] * Math.cos(d[1]),
    d[0] * Math.sin(d[1])
  ])
}

// function wrap(text, width, x) {
//
//
//   text.each(function(d) {
//
//     var text = d3.select(this),
//         words = text.text().split(/\s+/).reverse(),
//         word,
//         line = [],
//         lineNumber = 0,
//         lineHeight = 1.1, // ems
//         dy = '1',
//         tspan = text.text(null)
//           .append("tspan")
//           .attr('transform', `translate(${0},${0})`)
//     while (word = words.pop()) {
//       line.push(word);
//       tspan.text(line.join(" "));
//       if (tspan.node().getComputedTextLength() > width) {
//         line.pop();
//         tspan.text(line.join(" "));
//         line = [word];
//         tspan = text.append("tspan").attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
//       }
//     }
//   });
// }

export {
  toCartesian,
  // wrap
}
